import { CredentialsNotFoundException } from '@scalefast/core';
const CREDENTIALS_EXCEPTIONS = [{
  errorCode: '400',
  exception: new CredentialsNotFoundException()
}];
export default CREDENTIALS_EXCEPTIONS;
